module.exports = __webpack_public_path__ + "img/online.973f8dc3.svg";